import { OutlinedInput } from '@mui/material';
import { OutlinedInputProps } from '@mui/material/OutlinedInput/OutlinedInput';

import styles from './styles.module.scss';

export const InputSelect = (props: OutlinedInputProps) => {
  return (
    <OutlinedInput
      {...props}
      classes={{
        root: styles.root,
        error: styles.error,
      }}
    />
  );
};
